export default {
    data() {
        return {
            platformOptions: [
                { text: 'eBay', value: 'eBay' },
                { text: 'Discogs', value: 'Discogs' },
                { text: 'Web', value: 'Web' },
                { text: 'Amazon', value: 'Amazon' },
                { text: 'Phone', value: 'Phone' },
                { text: 'Email', value: 'Email' },
                { text: 'Walk-In', value: 'Walk-In' },
                { text: 'Post', value: 'Post' },
                { text: 'Employee', value: 'Employee' },
                { text: 'CD and LP', value: 'CD and LP' },
                { text: '11 Main', value: '11 Main', disabled: true },
                { text: 'Amazon Germany', value: 'Amazon Germany', disabled: true },
                { text: 'Amazon Spain', value: 'Amazon Spain', disabled: true },
                { text: 'Amazon France', value: 'Amazon France', disabled: true },
                { text: 'Amazon Italy', value: 'Amazon Italy', disabled: true },
                { text: 'Amazon UK', value: 'Amazon UK', disabled: true },
                { text: 'Auction', value: 'Auction', disabled: true },
                { text: 'Catalog', value: 'Catalog', disabled: true },
                { text: 'Fax', value: 'Fax', disabled: true },
                { text: 'Fnac', value: 'Fnac', disabled: true },
                { text: 'Musicstack', value: 'Musicstack', disabled: true },
                { text: 'Netsounds', value: 'Netsounds', disabled: true },
                { text: 'Nylvi', value: 'Nylvi', disabled: true },
                { text: 'Public Market', value: 'Public Market', disabled: true },
                { text: 'Reverb', value: 'Reverb', disabled: true },
                { text: 'GEMM', value: 'GEMM', disabled: true },
            ]
        }
    }
}